import { useState, useRef, useEffect } from 'react'
import cloud_left_1 from "../../assets/home/cloud_left_1.svg"
import cloud_left_2 from "../../assets/home/cloud_left_2.svg"
import cloud_left_3 from "../../assets/home/cloud_left_3.svg"
import cloud_mid_1 from "../../assets/home/cloud_mid_1.svg"
import cloud_mid_2 from "../../assets/home/cloud_mid_2.svg"
import cloud_mid_3 from "../../assets/home/cloud_mid_3.svg"
import cloud_right_1 from "../../assets/home/cloud_right_1.svg"
import cloud_right_2 from "../../assets/home/cloud_right_2.svg"
import cloud_right_3 from "../../assets/home/cloud_right_7.svg"
import home_1 from "../../assets/home/home_1.jpg"
import styles from "../../styles/componentStyles/homeTransition.module.css"
import Home from './Home'
// import home_1 from "../../assets/home/home_1.jpg";
import HomePageComp from './HomePageComp'
import gsap from 'gsap'
import React from 'react'
// import Loader from '../../components/Loader'

const HomeTransition = () => {

    // const [loading, setLoading] = useState(true);

    const [isExplore, setIsExplore] = useState("");
    const [showPage, setShowPage] = useState(false);


    // useEffect(() => {
    //     setLoading(true)
    //     let timeout = setTimeout(() => { setLoading(false) }, 2000);
    //     return () => clearTimeout(timeout);
    // }, []);

    useEffect(() => {

        const initialAnimate = () => {
            gsap.fromTo("#cloudLeft", { x: -200 }, { x: 30, duration: 2, ease: "back.out(1.7)" });
            gsap.fromTo("#cloudRight", { x: 200 }, { x: -30, duration: 2, ease: "back.out(1.7)" });
            gsap.fromTo("#btn", { y: 200 }, { y: -30, duration: 2, ease: "back.out(1.7)" });
            gsap.fromTo("#cloudMidRight", { x: -200 }, { x: 30, duration: 2, ease: "back.out(1.7)" });
            gsap.fromTo("#cloudMidLeft", { x: 200 }, { x: -30, duration: 2, ease: "back.out(1.7)" });
            gsap.fromTo("#cloudMidLeftUp", { x: 200 }, { x: -30, y: -50, duration: 2, ease: "back.out(1.7)" });
            gsap.fromTo("#cloudMidUp", { x: -200 }, { x: 30, duration: 2, ease: "back.out(1.7)" });
        }

        const clickAnimate = () => {
            gsap.fromTo("#cloudLeft", { x: 30 }, { x: -2000, duration: 3, ease: "power1.out" });
            gsap.fromTo("#cloudRight", { x: -30 }, { x: 2000, duration: 3, ease: "power1.out" });
            gsap.fromTo("#cloudMidRight", { x: -30 }, { x: 1000, duration: 3, ease: "power1.out" });
            gsap.fromTo("#cloudMidLeft", { x: 30 }, { x: -2000, duration: 3, ease: "power1.out" });
            gsap.fromTo("#cloudMidLeftUp", { x: 30 }, { x: -2009, y: -50, duration: 3, ease: "power1.out" });
            gsap.to("#cloudMidUp", { y: -3000, duration: 3, ease: "power1.out" });
            gsap.to("#btn", { autoAlpha: 0, duration: 1, ease: "power1.out" });
            gsap.to("#homeBack", { autoAlpha: 0, delay: 2, onComplete: () => { setShowPage(true); } })
            setTimeout(() => {
                document.getElementById("imageback").style.display = "none"
            }, 4000);
        }

        const skipAnimate = () => {
            gsap.to("#page", { height: 0, autoAlpha: 0, duration: 1, ease: "power1.out", onComplete: () => setShowPage(true) })
            gsap.fromTo("#skip", { autoAlpha: 0, height: 0 }, { autoAlpha: 1, height: '100%', duration: 1, ease: "power1.out" })
        }

        if (isExplore === "explored") {
            clickAnimate();
        }
        else if (isExplore === "skip") {
            clickAnimate();
            setTimeout(() => {
                skipAnimate();
            }, 2000);
        }
        else {
            setTimeout(() => {
                initialAnimate();
            }, 0);
        }
    }, [isExplore])

    return (
        // loading ? <Loader /> :
            <>
                <div id='page' className={styles.home_transition}>
                    <div id='imageback' className={styles.home_transition___background}>
                        <img src={home_1} alt="" />
                    </div>
                    <div id='homeBack' className={styles.home_transition___cloud}>
                        <div className={styles.home_transition___cloud_left}>
                            <img id="cloudLeft" src={cloud_left_3} alt="home" />
                            <img id="cloudLeft" src={cloud_left_2} alt="home" />
                            <img id="cloudLeft" src={cloud_left_1} alt="home" />
                            <img id="cloudMidLeft" src={cloud_left_2} alt="home" />
                            <img id="cloudMidLeftUp" src={cloud_mid_1} alt="home" />
                            <img id="cloudMidLeft" src={cloud_mid_2} alt="home" />
                        </div>
                        <div className={styles.home_transition___cloud_right}>
                            <img id="cloudMidRight" src={cloud_mid_3} alt="home" />
                            <img id="cloudMidUp" src={cloud_right_3} alt="home" />
                            <img id="cloudRight" src={cloud_right_2} alt="home" />
                            <img id="cloudRight" src={cloud_right_1} alt="home" />
                        </div>
                    </div>
                    <div id='btn' className={styles.home_transition___btn}>
                        <button onClick={() => setIsExplore("explored")}>Explore North</button>
                        <button onClick={() => setIsExplore("skip")}>Skip Transition</button>
                    </div>
                </div>
                {isExplore === "explored" && showPage &&
                    <div id='homePage'>
                        <Home show={isExplore === "explored"} />
                    </div>
                }
                {isExplore === "skip" && showPage &&
                    <div id='skip'>
                        <HomePageComp />
                    </div>
                }
            </>
    )
}

export default HomeTransition